// Import constants
import { ErrorShowType, l } from 'constants/common';

const formulaFilterValidationScenario = () => ({
    Name: {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: [
            {
                ValidationType: 'required',
                ErrorMessage: l.CannotBeEmpty,
                ParametersValues: null,
            },
            {
                ValidationType: 'firstSymbol',
                ErrorMessage: l.NameFirstCharacterCantBeASymbol,
                ParametersValues: /^[\p{L}0-9]/gu,
            },
            {
                ValidationType: 'minLength',
                ErrorMessage: l.MustContainMinimumCharacters,
                ParametersValues: '3',
            },
            {
                ValidationType: 'maxLength',
                ErrorMessage: l.MustContainMaximumCharacters,
                ParametersValues: '50',
            },
        ],
    },
    Description: {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: [
            {
                ValidationType: 'maxLength',
                ErrorMessage: l.MustContainMaximumCharacters,
                ParametersValues: '250',
            },
        ],
    },
    // QueryConfigurations: {
    //     isValid: null,
    //     value: {},
    //     type: ErrorShowType.Toaster,
    //     errorText: '',
    //     paramValue: '',
    //     validationCredentials: [
    //         {
    //             ValidationType: 'queryConfigurations',
    //             ErrorMessage: l.PleaseAddFilters,
    //             ParametersValues: 'false',
    //         },
    //     ],
    // },
});

export { formulaFilterValidationScenario };
